"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.balanceSheetResponse = exports.asOfQuery = exports.incomeStatementResponse = exports.statementSection = exports.generalLedgerResponse = exports.generalLedgerAccount = exports.accountLedgerResponse = exports.accountLedgerLine = exports.reportPeriodQuery = exports.trialBalanceResponse = exports.trialBalanceRow = exports.journalDto = exports.openingBalanceRequest = exports.postJournalRequest = exports.sourceType = exports.journalLineInput = exports.taxSnapshot = exports.counterparty = exports.accountDto = exports.subledger = exports.statement = exports.normalBalance = exports.accountClass = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
exports.accountClass = zod_1.z.enum([
    'asset',
    'liability',
    'equity',
    'revenue',
    'cogs',
    'expense',
    'other',
]);
exports.normalBalance = zod_1.z.enum(['debit', 'credit', 'mixed']);
exports.statement = zod_1.z.enum(['BS', 'PL']);
exports.subledger = zod_1.z.enum([
    'customer',
    'supplier',
    'cashbox',
    'bank_or_wallet',
    'inventory',
    'fixed_asset',
    'tax',
    'employee',
]);
exports.accountDto = zod_1.z.object({
    id: common_1.uuid,
    code: common_1.accountCode,
    parentCode: common_1.accountCode.nullable(),
    nameAr: zod_1.z.string().min(1),
    nameEn: zod_1.z.string().nullable(),
    accountClass: exports.accountClass,
    normalBalance: exports.normalBalance,
    statement: exports.statement,
    subledger: exports.subledger.nullable(),
    isPostable: zod_1.z.boolean(),
    isSystem: zod_1.z.boolean(),
    status: zod_1.z.string(),
});
exports.counterparty = zod_1.z.object({
    type: zod_1.z.enum(['customer', 'supplier', 'employee', 'other']),
    id: zod_1.z.string().min(1),
    allocationRef: zod_1.z.string().nullish(),
});
exports.taxSnapshot = zod_1.z.object({
    ruleId: zod_1.z.string().min(1),
    ruleVersion: zod_1.z.string().min(1),
    treatment: zod_1.z.enum(['standard', 'zero', 'exempt', 'out_of_scope', 'table', 'withholding']),
    ratePercent: zod_1.z.string(),
    base: common_1.moneyString,
    amount: common_1.moneyString,
    effectiveFrom: common_1.isoDate,
    recoverable: zod_1.z.boolean(),
});
exports.journalLineInput = zod_1.z
    .object({
    accountCode: common_1.accountCode,
    debit: common_1.moneyString.default('0'),
    credit: common_1.moneyString.default('0'),
    currency: common_1.currencyCode,
    amountCurrency: common_1.moneyString,
    currencyRate: common_1.moneyString.default('1'),
    counterparty: exports.counterparty.nullish(),
    cashboxId: zod_1.z.string().nullish(),
    bankAccountId: zod_1.z.string().nullish(),
    tax: exports.taxSnapshot.nullish(),
    dimensions: zod_1.z
        .object({
        projectId: zod_1.z.string().nullish(),
        serviceId: zod_1.z.string().nullish(),
        costCenter: zod_1.z.string().nullish(),
    })
        .nullish(),
    memo: zod_1.z.string().max(500).nullish(),
})
    .strict();
exports.sourceType = zod_1.z.enum([
    'manual_journal',
    'opening_balance',
    'sales_invoice',
    'sales_credit_note',
    'sales_debit_note',
    'customer_receipt',
    'customer_advance',
    'receipt_application',
    'advance_recognition',
    'purchase_invoice',
    'purchase_debit_note',
    'purchase_credit_note',
    'supplier_payment',
    'expense',
    'treasury_transfer',
    'prepaid_payment',
    'prepaid_amortization',
    'fixed_asset_purchase',
    'depreciation',
    'stock_receipt',
    'stock_issue',
    'stock_opening',
    'stock_adjustment',
    'period_close',
    'reversal',
    'data_migration',
]);
/** طلب ترحيل قيد. المفتاح يُرسل فى الترويسة لا فى الحمولة. */
exports.postJournalRequest = zod_1.z
    .object({
    sourceType: exports.sourceType,
    sourceId: zod_1.z.string().min(1),
    postingDate: common_1.isoDate,
    reference: zod_1.z.string().max(64).nullish(),
    memo: zod_1.z.string().max(500).nullish(),
    lines: zod_1.z.array(exports.journalLineInput).min(2),
})
    .strict();
/**
 * قيد الافتتاح: السطور فقط وتاريخ أول يوم فى السنة المالية. المصدر يشتقه الخادم
 * (`opening-<السنة>`) فلا افتتاحيتان لنفس السنة. وغير المتزن يُرفض أو يُكمَّل بسطر فرق
 * حسب إعداد الشركة `opening.difference` (ADR-0006).
 */
exports.openingBalanceRequest = zod_1.z
    .object({
    postingDate: common_1.isoDate,
    reference: zod_1.z.string().max(64).nullish(),
    memo: zod_1.z.string().max(500).nullish(),
    lines: zod_1.z.array(exports.journalLineInput).min(2),
})
    .strict();
exports.journalDto = zod_1.z.object({
    id: common_1.uuid,
    companyId: common_1.uuid,
    fiscalPeriodId: common_1.uuid,
    number: zod_1.z.string().nullable(),
    status: zod_1.z.enum(['DRAFT', 'POSTED', 'REVERSED']),
    sourceType: exports.sourceType,
    sourceId: zod_1.z.string().nullable(),
    postingDate: common_1.isoDate,
    reference: zod_1.z.string().nullable(),
    memo: zod_1.z.string().nullable(),
    totalDebit: common_1.moneyString,
    totalCredit: common_1.moneyString,
    postedAt: zod_1.z.string().nullable(),
    lines: zod_1.z.array(exports.journalLineInput.extend({
        id: common_1.uuid,
    })),
});
exports.trialBalanceRow = zod_1.z.object({
    accountCode: common_1.accountCode,
    nameAr: zod_1.z.string(),
    debit: common_1.moneyString,
    credit: common_1.moneyString,
    balance: common_1.moneyString,
});
exports.trialBalanceResponse = zod_1.z.object({
    companyId: common_1.uuid,
    from: common_1.isoDate,
    to: common_1.isoDate,
    rows: zod_1.z.array(exports.trialBalanceRow),
    totalDebit: common_1.moneyString,
    totalCredit: common_1.moneyString,
    isBalanced: zod_1.z.boolean(),
});
/** فترة تقرير: التاريخان شاملان، والبداية لا تتجاوز النهاية. */
exports.reportPeriodQuery = zod_1.z
    .object({
    from: common_1.isoDate,
    to: common_1.isoDate,
})
    .refine((value) => value.from <= value.to, {
    message: 'from must not be after to',
    path: ['from'],
});
/** سطر فى كشف الحساب — من سطر قيد منشور واحد، ومعه الرصيد بعده. */
exports.accountLedgerLine = zod_1.z.object({
    journalId: common_1.uuid,
    journalNumber: zod_1.z.string().nullable(),
    lineNumber: zod_1.z.number().int(),
    postingDate: common_1.isoDate,
    sourceType: exports.sourceType,
    reference: zod_1.z.string().nullable(),
    /** بيان السطر إن وُجد، وإلا بيان القيد. */
    memo: zod_1.z.string().nullable(),
    debit: common_1.moneyString,
    credit: common_1.moneyString,
    runningBalance: common_1.moneyString,
});
/**
 * كشف حساب لفترة. الأرصدة **بطبيعة الحساب**: مدين للأصول والمصروفات، دائن
 * للخصوم والإيرادات — فالرصيد الموجب يعنى «فى اتجاهه الطبيعى» كما فى الميزان.
 */
exports.accountLedgerResponse = zod_1.z.object({
    companyId: common_1.uuid,
    account: zod_1.z.object({
        code: common_1.accountCode,
        nameAr: zod_1.z.string(),
        normalBalance: exports.normalBalance,
    }),
    from: common_1.isoDate,
    to: common_1.isoDate,
    openingBalance: common_1.moneyString,
    lines: zod_1.z.array(exports.accountLedgerLine),
    totalDebit: common_1.moneyString,
    totalCredit: common_1.moneyString,
    closingBalance: common_1.moneyString,
});
/** حساب واحد داخل الأستاذ العام — نفس كشف الحساب بلا ترويسة الشركة والفترة. */
exports.generalLedgerAccount = exports.accountLedgerResponse.omit({
    companyId: true,
    from: true,
    to: true,
});
/**
 * الأستاذ العام لفترة: كشف كل حساب طرفى له رصيد افتتاحى أو حركة، مرتبة بالكود.
 * الإجماليان مجموع حركة الفترة على كل الحسابات — متساويان دائمًا لأن كل قيد متزن،
 * ويساويان إجمالى الميزان للفترة نفسها.
 */
exports.generalLedgerResponse = zod_1.z.object({
    companyId: common_1.uuid,
    from: common_1.isoDate,
    to: common_1.isoDate,
    accounts: zod_1.z.array(exports.generalLedgerAccount),
    totalDebit: common_1.moneyString,
    totalCredit: common_1.moneyString,
});
/** قسم فى قائمة مالية: حسابات غير صفرية بمبالغها فى اتجاه القسم، ومجموعها. */
exports.statementSection = zod_1.z.object({
    rows: zod_1.z.array(zod_1.z.object({ code: common_1.accountCode, nameAr: zod_1.z.string(), amount: common_1.moneyString })),
    total: common_1.moneyString,
});
/**
 * قائمة الدخل لفترة. الإيرادات والبنود الأخرى موجبها ربح، والتكلفة والمصروفات موجبها
 * عبء. صافى الربح = Σ(دائن − مدين) لحسابات النتيجة، والأقسام تقسيم عرض لا أكثر.
 */
exports.incomeStatementResponse = zod_1.z.object({
    companyId: common_1.uuid,
    from: common_1.isoDate,
    to: common_1.isoDate,
    revenue: exports.statementSection,
    costOfSales: exports.statementSection,
    grossProfit: common_1.moneyString,
    expenses: exports.statementSection,
    operatingProfit: common_1.moneyString,
    other: exports.statementSection,
    netIncome: common_1.moneyString,
});
exports.asOfQuery = zod_1.z.object({ asOf: common_1.isoDate });
/**
 * المركز المالى فى تاريخ. `unclosedResult` نتيجة لم تُقفل بعد إلى الأرباح المرحلة
 * (لا قيود إقفال بعد)، فتظهر ضمن حقوق الملكية حتى تتزن المعادلة.
 */
exports.balanceSheetResponse = zod_1.z.object({
    companyId: common_1.uuid,
    asOf: common_1.isoDate,
    assets: exports.statementSection,
    liabilities: exports.statementSection,
    equity: exports.statementSection,
    unclosedResult: common_1.moneyString,
    totalEquity: common_1.moneyString,
    totalLiabilitiesAndEquity: common_1.moneyString,
    isBalanced: zod_1.z.boolean(),
});
//# sourceMappingURL=ledger.js.map